import Google from "../../assets/icons/google-play.svg";
import Apple from "../../assets/icons/apple.svg";
import Mobile from "../../assets/images/mobile-phone.png";
const DownloadApp = () => {
  return (
    <div className="bg-blue bg-downloadBg">
      <div className="container mx-auto pt-8 flex items-end justify-center">
        <div className="flex flex-col md:flex-row items-center justify-end gap-14  md:w-[80%]">
          <div className="flex flex-col text-white items-center md:items-start gap-4 px-4 md:pr-10">
            <div className="head text-xl md:text-2xl">
              Get the Touramp app Now!
            </div>
            <div className="font-normal text-sm md:text-base text-center md:text-start">
              Be your own boss! Enjoy flexibility, freedom and competitive
              earnings by delivering with Touramp.
            </div>
            <div className="flex gap-3 text-black whitespace-nowrap">
              <div className="bg-white flex rounded-l-full rounded-r-full p-1 px-6 gap-2 items-center cursor-pointer">
                <img src={Google} alt="" className="md:w-8  md:h-8 " />
                <div className="flex flex-col">
                  <div className="text-xs">Get it on</div>
                  <div className="text-sm font-semibold">Playstore</div>
                </div>
              </div>
              <div className="bg-white flex rounded-l-full rounded-r-full p-1 px-5 gap-2 items-center cursor-pointer">
                <img src={Apple} alt="" className="md:w-8  md:h-8 " />
                <div className="flex flex-col">
                  <div className="text-xs">Download on</div>
                  <div className="text-sm font-semibold">Appstore</div>
                </div>
              </div>
            </div>
          </div>
          <div className="">
            <img src={Mobile} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadApp;
